import { DATE_FORMAT, MOMENT_TIMESTAMP } from './../../../utils/constants';
import dayjs from 'dayjs';
import { ServiceStorage } from '../../service/storage-service/service-storage.service';
import { SessionStorageService } from '../../service/storage/session-storage.service';
import { StorageService } from '../../service/storage/storage.service';
import { ScheduleModel } from './schedule.model';
import { QuotationScheduleVOV2 } from '../quotation/quotation-scheduleV2.model';
import { QuotationVOsV2 } from '../quotation/QuotationVOV2.model';
import { quotationIolmParts } from '../quotation/quotation-iolm-parts.model';
import { IRecall } from '@core/interface';
import { SchedulingModalityEnum } from '@core/enums';
export class OpenScheduleModel {

  "country": string;
  "division": number;
  "dealer": number;
  "advisor": number;
  "scheduleDate": string; // yyyy-MM-dd
  "scheduleHour": number;
  "scheduleSource": string; // D = dealer, M = mobile, W = Web
  "scheduleType": string; // R
  "customerRemark": string; // observação
  "advisorRemark": string; // null
  "vin": string;
  "vehiclePlate": string;
  "towTruckNeeded": string; // N
  "model": string | null;
  "customerId": string; // customer_K da tabela 200
  "contactCustomerId": string | number; // customer_K da tabela 200 = será igual customer k
  "group": string | null;
  "offeredServices": number[];
  "recallVOs": IRecall[];
  "quotationScheduleVO": QuotationScheduleVOV2; // pra é usado que? -> Cotação inicial
  "createUser": string; // user
  "createS": string; // data
  "scheduleUser": string; // user
  "sendEmail": boolean;
  "scheduleModality": SchedulingModalityEnum;
  "iolmParts": quotationIolmParts[];
  "lastKm": number | null;
  "oilLifeRemaining": number | null;
  "iolmMonths": number;
  "customerWaiting": boolean;

  constructor(
    schedule: ScheduleModel,
    sessionStorage: StorageService,
    serviceStorage: ServiceStorage,
    session: SessionStorageService,
    customerWaiting: boolean = false
  ) {
    this.division = Number(schedule.division);
    this.dealer = schedule.dealer;
    this.advisor = schedule.advisor;
    this.country = schedule.country;
    this.scheduleSource = schedule.scheduleSource ? schedule.scheduleSource : session.getSessionUser().source;
    this.scheduleType = 'R';
    this.customerRemark = (serviceStorage.services.details) ? serviceStorage.services.details : "";
    this.customerId = '';
    this.contactCustomerId = schedule.contactCustomerId; // ID na 600 = 3055012
    this.sendEmail = true;
    this.scheduleDate = dayjs(schedule.scheduleDate).format(DATE_FORMAT);
    this.scheduleHour = schedule.scheduleHour;
    this.createS = dayjs().format(MOMENT_TIMESTAMP);
    this.createUser = 'WEB-' + this.customerId;
    this.scheduleUser = this.createUser;
    this.vin = schedule.vin;
    this.vehiclePlate = schedule.vehiclePlate;
    this.towTruckNeeded = schedule.towTruckNeeded;
    this.model = schedule.model;
    this.group = schedule.group;
    this.scheduleModality = SchedulingModalityEnum.GENERAL_REPAIR;
    this.scheduleType = 'R';
    this.quotationScheduleVO = new QuotationScheduleVOV2();
    this.iolmParts = schedule.iolmParts;
    this.lastKm = schedule.lastKm;
    this.oilLifeRemaining = schedule.oilLifeRemaining;
    this.iolmParts = schedule.iolmParts;
    this.iolmMonths = schedule.iolmMonths;
    this.customerWaiting = customerWaiting;

    if (schedule.advisor) {
      this.advisor = schedule.advisor;
    }

    if (schedule.dealer) {
      const dealer = schedule.dealer;
      this.dealer = dealer;
    }

    if (sessionStorage.userVehicle) {
      const userVehicle = sessionStorage.userVehicle;
      this.vin = userVehicle.vin;
      this.vehiclePlate = userVehicle.licenseplate;
      this.model = userVehicle.model;
      this.group = userVehicle.modelGroup;
      this.towTruckNeeded = 'N';
    }

    const recall = (serviceStorage.recall.hasRecall) ? serviceStorage.recall.recall : [];
    if (recall && recall.length > 0) {
      this.recallVOs = recall;
    }

    this.quotationScheduleVO.quotationVOs = [];
    this.offeredServices = [];

    const copySchedule = JSON.parse(JSON.stringify(schedule));
    copySchedule.quotationScheduleVO.quotationVOs.forEach((service: QuotationVOsV2) => {
      if ('quotationPartVOs' in service && !service.service.toUpperCase().includes("KIT")) {
        service.reviewService = this.#setReviewService(serviceStorage);
      }

      if (service.serviceId !== null) {
        service.price = this.#recalculatePrice(service);
        service.discount = this.#recalculateDiscount(service);

        this.#formatPriceForDealer(service, serviceStorage);

        this.quotationScheduleVO.quotationVOs.push(service);
        this.offeredServices.push(service.serviceId);
      }
    });
  }

  #setReviewService(serviceStorage: ServiceStorage): string | undefined {
    return (serviceStorage.services.revisionInfo && serviceStorage.services.revisionInfo.length > 0)
      ? serviceStorage.services.revisionInfo[0].service
      : undefined;
  }

  #recalculatePrice(service: QuotationVOsV2): number | null {
    return service.price === null || service.price === undefined ? null : service.price * 100;
  }

  #recalculateDiscount(service: QuotationVOsV2): number | undefined {
    return service.modality !== undefined && service.modality !== SchedulingModalityEnum.DEALER && service.discount !== undefined && service.discount !== null ? service.discount * 100 : service.discount;
  }

  #formatPriceForDealer(service: QuotationVOsV2, serviceStorage: ServiceStorage): void {
    if (service.service?.toLowerCase() !== 'recall') {
      if (service.costless === false && service.price === 0) {
        service.price = null;
      }

      if (('reviewService' in service) && serviceStorage.isfordProtectToDiscount) {
        service.price = 0;
      }
    } else {
      service.costless = true;
      service.price = 0;
    }

    if (serviceStorage.revisionDefault && serviceStorage.getServices().selectedRevision.serviceId === service.serviceId) service.price = null;
  }
}
